var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('po-status-badge',{attrs:{"value":_vm.value.status,"error":_vm.error,"success":_vm.success,"warning":_vm.warning}})}
var staticRenderFns = []

export { render, staticRenderFns }